
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allRooms"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"response"},"name":{"kind":"Name","value":"allRooms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scenario_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timer_total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"game_clock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public_opinion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meter_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"infobox"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"p_role_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"n_role_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"question_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"clock_option"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deleted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"episode"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scenario_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"episode_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"real_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"in_game_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"start_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intro_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theme"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":434}};
    doc.loc.source = {"body":"query allRooms {\n\tresponse: allRooms {\n\t\tid\n\t\tname\n\t\tpin\n\t\towner_id\n\t\tscenario_id\n\t\ttimer\n\t\ttimer_total\n\t\tgame_clock\n\t\tstate\n\t\tstatus\n\t\tpublic_opinion\n\t\tmeter_label\n\t\tcreated\n\t\tquestions\n\t\tinfobox {\n\t\t\tid\n\t\t\trole_id\n\t\t\tp_role_id\n\t\t\tn_role_id\n\t\t\tquestion_id\n\t\t}\n\t\tclock_option\n\t\tdeleted\n\t\tepisode {\n\t\t\tscenario_id\n\t\t\tname\n\t\t\tepisode_number\n\t\t\treal_duration\n\t\t\tin_game_duration\n\t\t\tstart_time\n\t\t\tintro\n\t\t\tintro_duration\n\t\t\ttheme\n\t\t}\n\t}\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["allRooms"] = oneQuery(doc, "allRooms");
        
